/**
 * Tipos para las plantillas transaccionales de correo de seguimiento
 * (CallSidebar post_call).
 *
 * Espejo de `app/api/endpoints/crm/follow_up_emails.py` (backend migrofast).
 * Las plantillas son prehechas, sin personalización por parte del agente.
 */

export type FollowUpEmailTemplateId =
  | 'follow_up_missed_call'
  | 'follow_up_promo_month'
  | 'follow_up_consultation';

/** IDs válidos en runtime — útil para validar y para iterar las 3 tarjetas. */
export const FOLLOW_UP_EMAIL_TEMPLATE_IDS: readonly FollowUpEmailTemplateId[] =
  ['follow_up_missed_call', 'follow_up_promo_month', 'follow_up_consultation'];

/** Metadatos de UI para cada plantilla (sólo lado cliente: título, emoji,
 *  descripción corta). Se mantiene junto al type para que el render del
 *  bloque pueda mapear `id → label/desc` sin pedir nada al backend. */
export interface FollowUpEmailTemplateMeta {
  id: FollowUpEmailTemplateId;
  label: string;
  description: string;
  emoji: string;
}

export const FOLLOW_UP_EMAIL_TEMPLATES: readonly FollowUpEmailTemplateMeta[] = [
  {
    id: 'follow_up_missed_call',
    label: 'Llamada perdida',
    description: 'Te llamamos y no pudimos hablar — empático.',
    emoji: '📞',
  },
  {
    id: 'follow_up_promo_month',
    label: 'Promo del mes',
    description: 'Regularización con descuento — comercial.',
    emoji: '🎁',
  },
  {
    id: 'follow_up_consultation',
    label: 'Consulta gratis',
    description: 'Asesoramiento gratis sin compromiso — educativo.',
    emoji: '💬',
  },
];

/** Respuesta del endpoint `POST /crm/contacts/{id}/send-follow-up-email`. */
export interface SendFollowUpEmailResponse {
  sent: boolean;
  message_id: string | null;
  to_email: string | null;
}
